import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete, Checkbox,FormControl, TextField } from '@mui/material';

interface MultiSelectDropdownProps<T extends { id: string }> {
    disabled?: boolean;
    value: T[];
    onChange: (items: T[]) => void;
    options: T[];
    getOptionLabel: (option: T) => string;
    label: string;
    noOptionsText?: string;
}

export function MultiSelectDropdown<T extends { id: string }>({
    disabled = false,
    value,
    onChange,
    options,
    getOptionLabel,
    label,
    noOptionsText,
}: Readonly<MultiSelectDropdownProps<T>>) {
    const handleChange = (_event: React.SyntheticEvent, newItems: T[]) => {
        onChange(newItems);
    };

    return (
        <FormControl>
            <Autocomplete
                disabled={disabled}
                value={value}
                onChange={handleChange}
                multiple
                options={options}
                disableCloseOnSelect
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={(option, val) => option.id === val.id}
                noOptionsText={noOptionsText}
                renderOption={(optionProps, option, { selected }) => {
                    const { key, ...restProps } = optionProps;
                    return (
                        <li key={key} {...restProps}>
                            <Checkbox
                                icon={<CheckBoxOutlineBlank fontSize={'small'} />}
                                checkedIcon={<CheckBox fontSize={'small'} />}
                                style={{ marginRight: '8px' }}
                                checked={selected}
                            />
                            {getOptionLabel(option)}
                        </li>
                    );
                }}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                    />
                )}
            />
        </FormControl>
    );
}
